import React from "react";

// Components
import {
  // BlogArticles,
  DeliveryMap,
  HomeAbout,
  HomeOverLay,
  HomeServicesOffered,
  Interested,
  SEOHead,
} from "../Components";

export const Home = () => {
  return (
    <>
      {/* SEO Head for home page */}
      <SEOHead pageType="home" canonical={window.location.origin} />

      <HomeOverLay />
      <HomeAbout />
      <DeliveryMap />
      <HomeServicesOffered />
      {/* <BlogArticles /> */}
      <Interested />
    </>
  );
};
